import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@parcel+watcher@2.5.1_@types+node@22.17.0_@unhead+vue@2.0.12_vue_09715b43e1d136ccd69c8d74f80c91f0/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}